/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
*/

@import '@spectrum/spectrum-variables/stylus/spectrum-light.styl'

:local(.root)
  width 100%
  height 100%

:local(.validation)
  border-bottom-color $spectrum-global-color-grey300
  border-bottom-style solid
  border-bottom-width 1px
  padding 4px 0

:local(.basic)
  align-items center
  display flex
  justify-content space-between
  width 100%

:local(.textRow)
  align-items baseline
  display flex
  max-width 80%

  > *
    padding-right 16px

:local(.advanced)
  margin 0 32px

  textarea
    display block
    width 100%

:local(.actions)
  display flex
  flex-direction column
  justify-content right

:local(.validation):last-child
  border-bottom none
